"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fs = require("./fs");
exports.fs = fs;
